<template>
  <v-container fluid class="training-intents">
    <template v-if="currentView == 'list'">
      <div style="position: relative; min-height: 100vh">
        <v-premium-plan-popup
          v-if="$store.getters.getPackage != 'premium' || isCoachlab"
          :show-all="false"
          margin-top="65"
        ></v-premium-plan-popup>
        <div class="container-fluid" style="padding: 25px 15px">
          <div class="row">
            <div class="col s12 m8">
              <h1>{{ $t('Default Conversation') }}</h1>
            </div>
            <div class="col s12 m4 form-control">
              <input v-model="search" type="text" :placeholder="$t('Search')" />
            </div>
          </div>
          <div class="row">
            <div class="col s12 text-xs-left text-sm-right">
              <v-btn
                depressed
                outline
                color="primary"
                :loading="loading"
                :disabled="filterDefaultIntents.length == 0"
                @click="onExportTraining"
              >
                <em class="fas fa-file-export" />
                &nbsp;{{ $t('export') }}&nbsp;
                <v-premium-lock :inline="true"></v-premium-lock>
              </v-btn>
            </div>
          </div>
        </div>

        <v-container v-if="selectedBot.theme == 'universalutilities'" fluid>
          <div v-if="selectedBot.uu_areaname" class="primary--text">
            {{ selectedBot.uu_areaname }}
          </div>
          <template v-else>
            <multiselect
              v-model="uuAreaName"
              v-validate="'required'"
              :options="$store.state.uuAreaName"
              select-label
              selected-label
              :searchable="false"
              deselect-label
              data-vv-as="ประปา"
              data-vv-name="uuAreaName"
              @select="onSelectUuAreaName"
              @remove="onSelectUuAreaName('')"
            ></multiselect>
          </template>
        </v-container>
        <div v-if="firstloading">
          <scale-loader :color="$vuetify.theme.primary" height="35px" width="7px"></scale-loader>
        </div>
        <template v-else>
          <template v-if="filterDefaultIntents.length > 0">
            <div style="padding: 0 15px">
              <div>
                <div
                  style="
                    background: #eee;
                    padding: 15px 15px 0;
                    margin-bottom: 15px;
                    border-radius: 5px;
                  "
                >
                  <div class="row" style="margin-bottom: 0">
                    <div class="col s12 m5">
                      <v-checkbox
                        v-model="allSelected"
                        color="primary"
                        :label="$t('Select All')"
                        style="margin-top: 0"
                      ></v-checkbox>
                    </div>
                    <div class="col s12 m7 text-xs-left text-sm-right">
                      <v-btn
                        href="javascript:void(0)"
                        outline
                        color="grey"
                        :loading="loading || loadingIntent"
                        class="primaryButton"
                        :disabled="selected.length == 0"
                        style="margin-bottom: 5px"
                        @click="
                          $store.getters.getPackage == 'premium' && !isCoachlab
                            ? ignoreAll()
                            : false
                        "
                        >{{ $t('Delete') }}</v-btn
                      >
                      <v-btn
                        depressed
                        color="primary"
                        class="primaryButton"
                        href="javascript:void(0)"
                        :loading="loading || loadingIntent"
                        :disabled="selected.length == 0"
                        style="margin-bottom: 5px"
                        @click="createNewAll"
                        >{{ $t('Create new') }}</v-btn
                      >
                      <v-btn
                        depressed
                        color="primary"
                        class="primaryButton"
                        href="javascript:void(0)"
                        :loading="loading || loadingIntent"
                        :disabled="selected.length == 0"
                        style="margin-bottom: 5px"
                        @click="
                          currentDefaultIntents = selected
                          showModal = true
                        "
                        >{{ $t('Add existing') }}</v-btn
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <div class="container-fluid" style="padding: 0 15px">
            <div
              id="training_container"
              style="
                max-height: 600px;
                overflow-y: auto;
                border: 1px solid #eee;
                padding: 10px;
                border-radius: 5px;
              "
            >
              <div class="text-xs-center">
                <v-pagination
                  v-if="!loading"
                  v-model="pageNumber"
                  :length="pageCount"
                  class="mb-2"
                  @input="onClickPageinate"
                ></v-pagination>
              </div>
              <div class="row" style="margin-bottom: 0">
                <div class="col s12">
                  <template v-if="filterDefaultIntents.length > 0">
                    <div class="container-fluid">
                      <template v-if="view == 'tag'">
                        <ul class="tags">
                          <li
                            v-for="(intent, index) in filterDefaultIntents"
                            :key="'intent_' + intent.id + '_' + index"
                            class="tag"
                            :class="{ active: selected.includes(intent.questiondata) }"
                            style="
                              margin-right: 5px;
                              margin-bottom: 5px;
                              cursor: pointer;
                              text-align: left;
                            "
                            :title="intent.questiondata"
                            @click="handleSelectQuestionData(intent.questiondata)"
                          >
                            <span
                              :class="{
                                'fas fa-check-circle': selected.includes(intent.questiondata),
                                'far fa-circle': !selected.includes(intent.questiondata)
                              }"
                            ></span>
                            <div
                              style="
                                display: inline-block;
                                vertical-align: middle;
                                word-break: break-all;
                              "
                            >
                              {{ intent.questiondata }}
                            </div>
                            <template v-if="intent.count > 1">({{ intent.count }})</template>
                          </li>
                        </ul>
                      </template>

                      <template v-else>
                        <NewClassifyItem
                          v-for="(intent, index) in filterDefaultIntents"
                          :key="'intent_' + intent.id + '_' + index"
                          v-model="filterDefaultIntents[index]"
                          :loading-id="loadingId"
                          class="z-border-red"
                          style="padding: 10px 10px 0"
                          :excluded-intent-name="excludedIntentName"
                          @onAddExistingConversation="
                            currentDefaultIntents = []
                            currentDefaultIntents.push(intent.questiondata)
                            showModal = true
                          "
                          @onSaveTrainingConversation="saveTrainingIntent"
                          @onIgnore="onIgnore(intent.questiondata)"
                          @onSelect="onSelect(intent.questiondata)"
                        ></NewClassifyItem>
                      </template>
                    </div>
                  </template>
                  <template v-else>
                    <div class="text-xs-center" style="margin: 35px 0">
                      <img
                        src="/static/img/assets/setting/conversation.png"
                        alt
                        style="width: 230px"
                      />
                      <h3>{{ $t('No conversation') }}</h3>
                    </div>
                  </template>
                </div>
              </div>
              <div class="text-xs-center">
                <v-pagination
                  v-if="!loading"
                  v-model="pageNumber"
                  :length="pageCount"
                  class="mb-2"
                  @input="onClickPageinate"
                ></v-pagination>
              </div>
            </div>
          </div>
        </template>
      </div>

      <div style="height: 60px"></div>

      <v-dialog v-model="showModal" scrollable persistent max-width="1000">
        <v-card>
          <template v-if="showModal">
            <div class="pa-2">
              <h1>{{ $t('Training') }}</h1>
              <div class="form-control">
                <input v-model="searchIntent" type="text" :placeholder="$t('Search')" />
              </div>
            </div>

            <v-divider />
            <v-card-text style="max-height: 600px">
              <ul class="training-data" style="margin: 0; padding: 0">
                <li
                  v-for="(intent, index) in filterIntents"
                  :key="'intent_' + index"
                  class="item z-border-red mb-2"
                >
                  <v-layout class="training-title">
                    <v-flex class="pa-2">
                      {{ intent.intentname }}
                    </v-flex>
                    <v-flex shrink>
                      <v-btn color="primary" @click="addTrainingToConversation(intent)">
                        {{ $t('select') }}
                      </v-btn>
                    </v-flex>
                    <v-flex shrink>
                      <v-btn icon @click="handleSelectPreviewIntent(intent)">
                        <v-icon>
                          {{
                            currentIntent && currentIntent.id == intent.id
                              ? 'keyboard_arrow_up'
                              : 'keyboard_arrow_down'
                          }}
                        </v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  <template v-if="currentIntent && currentIntent.id == intent.id">
                    <v-divider />
                    <PreviewConversation
                      class="pa-2"
                      :show-multiple-channel="showMultipleChannel"
                      :intent="intent"
                      :answers="answers"
                      :tab="tab"
                      :multi-messages="{
                        fb_answers,
                        line_answers,
                        ig_answers,
                        ms_team_answers
                      }"
                      :fb_answers="fb_answers"
                      :line_answers="line_answers"
                      :ig_answers="ig_answers"
                      :ms_team_answers="ms_team_answers"
                      @handleChangeTab="tab = $event"
                    />
                  </template>
                </li>
              </ul>
            </v-card-text>

            <v-divider />
            <v-card-actions>
              <v-spacer />
              <v-btn color="primary" depressed @click="showModal = false">{{ $t('cancel') }}</v-btn>
              <v-spacer />
            </v-card-actions>
          </template>
        </v-card>
      </v-dialog>
    </template>
    <template v-else-if="currentView == 'create_new'">
      <div class="row">
        <div class="col s12">
          <manage-intent
            v-model="newIntent"
            :type="'add'"
            :excluded-intent-name="excludedIntentName"
            @close="onClose"
            @saveIntent="onSaveIntent"
          ></manage-intent>
        </div>
      </div>
    </template>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
// import datepicker from 'vuejs-datepicker'
import moment from 'moment'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import ManageIntent from '@/components/view/intent/intent-manage'
import intentApi from '@/api/intent.js'
import { handleResponse, handleApiError } from '@/api/util'

import PreviewConversation from '@/components/elements/Conversation/PreviewConversation'
import trainingApi from '@/api/training'
import autoTrainingApi from '@/api/auto-training'
import NewClassifyItem from './NewClassifyItem'

import XLSX from 'xlsx'
export default {
  name: 'TrainingComponent',
  components: {
    NewClassifyItem,
    // datepicker,
    ScaleLoader,
    ManageIntent,
    PreviewConversation
  },
  data: function () {
    return {
      tmp_intent: [],
      alltrainingdata: [],
      pageNumber: 1,
      size: 50,
      loadingId: '',
      currentView: 'list',
      training_intents: [],
      loading: false,
      loadingIntent: true,
      firstloading: true,
      loadingSearch: false,
      intents: [],
      search: '',
      searchIntent: '',
      showModal: false,
      currentDefaultIntents: [],
      allSelected: false,
      selectedDate: {
        start: moment().startOf('month').toDate(),
        end: moment().endOf('month').toDate()
      },
      currentFilter: 'this_month',
      ignoreInterval: undefined,
      ignoreCount: 0,
      view: 'tag',
      newIntent: {
        intentname: '',
        q_type: 'text',
        a_type: 'json',
        q_val: '',
        a_val: '[[]]',
        context_in: '',
        context_out: '',
        postidlist: '',
        userstatus: '',
        usertags: '',
        isShow: false,
        linenoti_status: false,
        linenoti_text: null,
        starttime: null,
        endtime: null,
        intentstatus: true
      },
      training_process_count: 0,
      loadingTraining: null,
      uuAreaName: '',
      currentIntent: null,

      trainingCount: 0,
      offset: 0,
      total: 0,
      tab: 'fb',
      selected: [],
      searchTimeout: null
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      isCoachlab: 'isCoachlab'
    }),
    pageCount: function () {
      let l = this.total
      let s = this.size
      return Math.ceil(l / s)
      // return 10
    },
    excludedIntentName: function () {
      const vm = this
      const result = vm.intents.map((intent) => {
        return intent && intent.intentname ? intent.intentname : null
      })

      return (result || []).join(',')
    },
    filterDefaultIntents: function () {
      const vm = this
      // const sorted = vm.training_intents.slice(0).sort(function (a, b) {
      //   const nameA = a.questiondata.toUpperCase()
      //   const nameB = b.questiondata.toUpperCase()
      //   if (nameA < nameB) {
      //     return -1
      //   } else if (nameA > nameB) {
      //     return 1
      //   }

      //   // names must be equal
      //   return 0
      // })

      //   const training = sorted.filter((intent) => {
      //     let isFound = false
      //     if (intent.questiondata != null && intent.questiondata != '') {
      //       isFound =
      //         intent.questiondata.toLowerCase().includes(vm.search.toLowerCase()) &&
      //         intent.training != true
      //     }
      //     return isFound
      //   })
      return vm.training_intents
    },
    filterIntents: function () {
      const vm = this
      vm.intents.slice(0).sort(function (a, b) {
        const nameA = a.intentname.toUpperCase() // ignore upper and lowercase
        const nameB = b.intentname.toUpperCase() // ignore upper and lowercase
        if (a.intentname[0] == '{' && a.intentname[a.intentname.length - 1] == '}') {
          return 1
        }
        if (b.intentname[0] == '{' && b.intentname[b.intentname.length - 1] == '}') {
          return -1
        }
        if (nameA < nameB) {
          return -1
        }
        if (nameA > nameB) {
          return 1
        }
        // names must be equal
        return 0
      })

      return vm.intents.filter((intent) => {
        if (intent && intent.intentname) {
          return intent.intentname.toLowerCase().includes(vm.searchIntent.toLowerCase())
        } else return false
      })
    },
    selectedQuestionData: function () {
      const questions = []
      const vm = this
      if (vm.filterDefaultIntents) {
        vm.filterDefaultIntents.map(function (el) {
          if (el.selected) {
            questions.push(el.questiondata)
          }
        })
      }
      return questions
    },
    showMultipleChannel() {
      if (!this.currentIntent) {
        return false
      }
      const hasMultipleChannel = this.conversationSocialChannelOptions.find((social) => {
        return (
          Object.prototype.hasOwnProperty.call(this.currentIntent, `${social.value}_val`) &&
          this.currentIntent[`${social.value}_val`]
        )
      })
      return hasMultipleChannel ? true : false
    },
    answers: function () {
      const vm = this
      if (!vm.currentIntent) {
        return [[]]
      }
      try {
        return vm.formatAnswer(vm.currentIntent.a_val, vm.currentIntent.a_type)
      } catch (error) {
        return [[]]
      }
    },
    fb_answers() {
      const vm = this
      if (!vm.currentIntent) {
        return [[]]
      }
      try {
        return vm.formatAnswer(vm.currentIntent.fb_val, 'json')
      } catch (error) {
        return [[]]
      }
    },
    line_answers() {
      const vm = this
      if (!vm.currentIntent) {
        return [[]]
      }
      try {
        return vm.formatAnswer(vm.currentIntent.line_val, 'json')
      } catch (error) {
        return [[]]
      }
    },
    ig_answers() {
      const vm = this
      if (!vm.currentIntent) {
        return [[]]
      }
      try {
        return vm.formatAnswer(vm.currentIntent.ig_val, 'json')
      } catch (error) {
        return [[]]
      }
    },
    ms_team_answers() {
      const vm = this
      if (!vm.currentIntent) {
        return [[]]
      }
      try {
        return vm.formatAnswer(vm.currentIntent.ms_team_val, 'json')
      } catch (error) {
        return [[]]
      }
    },
    replies: function () {
      const vm = this
      if (!vm.currentIntent) {
        return []
      }
      if (vm.currentIntent.quick_reply !== '' && vm.currentIntent.quick_reply != null) {
        return vm.currentIntent.quick_reply.split(',')
      } else {
        return []
      }
    }
  },
  watch: {
    search() {
      if (this.loading) return false
      if (this.searchTimeout) clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.loadTraining()
      }, 500)
    },
    allSelected: function (newVal, oldVal) {
      const vm = this
      if (newVal != oldVal) {
        vm.selectAll(newVal)
      }
    }
  },
  mounted: async function () {
    const vm = this
    if (vm.$store.getters.getPackage != 'premium' || vm.isCoachlab) {
      return false
    }
    if (vm.$route.query.datefrom) {
      vm.selectedDate.start = vm.$route.query.datefrom
    }
    if (vm.$route.query.dateto) {
      vm.selectedDate.end = vm.$route.query.dateto
    }
    if (vm.$route.query.datefrom || vm.$route.query.dateto) {
      vm.currentFilter = 'custom_date'
    }

    vm.firstloading = true
    try {
      const response = await vm.getTrainingConversation({ limit: vm.size, offset: vm.offset })
      vm.training_intents = response.training
      vm.total = response.total
    } catch (error) {
      console.error(error)
    }
    vm.firstloading = false
    this.loadingIntent = true
    try {
      vm.intents = []
      const intents = await vm.getIntent()
      vm.intents = intents
    } catch (error) {
      console.error(error)
    }
    this.loadingIntent = false
  },
  methods: {
    async updateTrainedToDefaultChatlog(payload) {
      try {
        const response = await autoTrainingApi.putUpdateDefaultChatlog({
          data: {
            page_id: this.selectedBot.pageid,
            questiondata: payload.questiondata,
            newintent: payload.intentname
          }
        })
        if (response) {
          return response
        }
      } catch (error) {
        console.error(error)
        handleApiError(error)
        return false
      }
    },
    handleSelectQuestionData(questiondata) {
      if (this.selected.includes(questiondata)) {
        this.selected.splice(this.selected.indexOf(questiondata), 1)
      } else {
        this.selected.push(questiondata)
      }
    },
    onSelect(item) {
      if (this.selected.includes(item)) {
        this.selected.splice(this.selected.indexOf(item), 1)
      } else {
        this.selected.push(item)
      }
    },
    handleSelectPreviewIntent(intent) {
      if (!this.currentIntent || this.currentIntent.id != intent.id) {
        this.currentIntent = intent
      } else {
        this.currentIntent = null
      }
    },
    onSelectUuAreaName: function (type) {
      const vm = this
      vm.loading = true
      vm.uuAreaName = type
      this.getTrainingConversation().then(
        function () {
          vm.loading = false
        },
        function (error) {
          console.error(error)
          vm.loading = false
        }
      )
    },

    async onClickPageinate(pageNum) {
      this.pageNumber = pageNum
      this.firstloading = true
      if (pageNum == 1) {
        this.offset = 0
      } else {
        this.offset = (pageNum - 1) * this.size
      }
      try {
        const response = await this.getTrainingConversation({
          limit: this.size,
          offset: this.offset
        })
        this.training_intents = response.training
        if (response.training.length == 0) {
          this.total = pageNum * this.size
        } else {
          this.total = response.total
        }
      } catch (error) {
        console.log(error)
      }
      this.firstloading = false
      await this.$nextTick()
      $('html, body').animate({
        scrollTop: 0
      })
      $('#training_container').animate({
        scrollTop: 0
      })
    },
    onSaveIntent: async function (payload) {
      const vm = this
      vm.loading = true
      vm.currentView = 'list'
      if (vm.selected && vm.selected.length > 0) {
        vm.loading = true
        const datapayload = {
          intentname: payload.intentname,
          questiondata: vm.selected
        }
        await vm.saveTrainingIntent(datapayload)

        vm.loading = false
      }
    },
    onClose: function () {
      this.currentView = 'list'
    },
    onSelectedStartDate: async function (value) {
      const vm = this
      vm.currentFilter = 'custom_date'
      if (moment(this.selectedDate.end).isBefore(value)) {
        this.selectedDate.end = value
      }
      this.selectedDate.start = value
    },
    createNewAll: function () {
      const vm = this

      vm.newIntent = {
        intentname: '',
        q_type: 'text',
        a_type: 'json',
        q_val: vm.selected.join(','),
        a_val: '[[]]',
        context_in: '',
        context_out: '',
        postidlist: '',
        userstatus: '',
        usertags: '',
        isShow: false,
        linenoti_status: false,
        linenoti_text: null,
        starttime: null,
        endtime: null,
        intentstatus: true
      }
      vm.currentView = 'create_new'
    },
    onSelectedEndDate: async function (value) {
      const vm = this
      vm.currentFilter = 'custom_date'
      if (moment(value).isBefore(this.selectedDate.start)) {
        this.selectedDate.start = value
      }
      this.selectedDate.end = value
    },
    async loadTraining() {
      this.loading = true
      try {
        const response = await this.getTrainingConversation({
          limit: this.size,
          offset: this.offset
        })
        this.training_intents = response.training
        this.total = response.total
      } catch (error) {
        console.error(error)
      }
      this.loading = false
    },
    onSelectedDate: async function () {
      const vm = this
      vm.loading = true
      try {
        vm.offset = 0
        const response = await vm.getTrainingConversation({ limit: vm.size, offset: vm.offset })
        vm.training_intents = response.training
        vm.total = response.total
        vm.pageNumber = 1
      } catch (error) {
        console.error(error)
      }
      vm.loading = false
    },
    changeDate: function (value) {
      const vm = this
      vm.currentFilter = value
      switch (value) {
        case 'today':
          vm.selectedDate.start = moment().toDate()
          vm.selectedDate.end = moment().toDate()
          vm.onSelectedDate()
          break

        case 'last_month':
          vm.selectedDate.start = moment().subtract(1, 'months').toDate()
          vm.selectedDate.end = moment().toDate()
          vm.onSelectedDate()
          break

        case 'this_month':
          vm.selectedDate.start = moment().startOf('month').toDate()
          vm.selectedDate.end = moment().endOf('month').toDate()
          vm.onSelectedDate()
          break

        case 'this_year':
          vm.selectedDate.start = moment().startOf('year').toDate()
          vm.selectedDate.end = moment().endOf('year').toDate()
          vm.onSelectedDate()
          break

        case 'last_365_day':
          vm.selectedDate.start = moment().subtract(365, 'days').toDate()
          vm.selectedDate.end = moment().toDate()
          vm.onSelectedDate()
          break
        case 'custom_date':
          break
      }
    },
    getTrainingConversation: async function (pageinate) {
      const vm = this

      let data = {
        page_id: vm.selectedBot.pageid,
        limit: pageinate.limit,
        offset: pageinate.offset,
        search: this.search
      }
      try {
        const response = await trainingApi.getNonClassified({ config: { params: data } })
        let training_intents = []
        training_intents = response.data.data.map((intent) => {
          let tmp_intent = intent
          tmp_intent.selected = false

          // let isFound = false
          // training_intents.forEach((value, index) => {
          //   if (value.id != tmp_intent.id && tmp_intent.questiondata == value.questiondata) {
          //     training_intents[index].count += 1
          //     training_intents[index].idlist.push(tmp_intent.id)
          //   }
          //   if (value.id != tmp_intent.id && tmp_intent.questiondata == value.questiondata) {
          //     isFound = true

          //     return false
          //   }
          // })

          // if (!isFound) {
          //   tmp_intent.count = 1
          //   Object.assign(tmp_intent, { idlist: [tmp_intent.id] })

          //   training_intents.push(tmp_intent)
          // }

          return {
            ...tmp_intent,
            count: tmp_intent.count
              ? typeof tmp_intent.count == 'string'
                ? parseInt(tmp_intent.count)
                : tmp_intent.count
              : 1
          }
        })

        console.log(training_intents)

        return {
          training: training_intents,
          total: response.data.total ? response.data.total : 0
        }
      } catch (error) {
        console.error(error)
      }
    },
    getIntent: async function () {
      let vm = this
      const params = {
        pageid: vm.selectedBot.pageid,
        sort_by: 'intentname',
        sort_type_available: 'asc'
      }
      try {
        const response = await intentApi.getIntent({ params })
        await handleResponse(response)
        const data = response.data.data
        if (data) {
          const intents = data.map((val) => {
            let intent = val
            intent.isShow = false
            intent.ableToDelete = true
            if (intent.intentname == '{default}') {
              intent.ableToDelete = false
              vm.default_intent = intent
            } else {
              return intent
            }
          })
          return intents
        }
      } catch (error) {
        handleApiError(error)
      }
    },
    addTrainingToConversation: async function (intent) {
      let vm = this
      if (
        !vm.currentDefaultIntents ||
        (vm.currentDefaultIntents && vm.currentDefaultIntents.length == 0)
      ) {
        return false
      }

      let data = {
        q_val: vm.currentDefaultIntents.join(','),
        pageid: vm.selectedBot.pageid
      }

      const result = await vm.$swal.fire({
        title: vm.$t('Do you want to add {question} to {intent}?', {
          question: (
            vm.currentDefaultIntents[0] + (vm.currentDefaultIntents.length > 1 ? '...' : '')
          )
            // eslint-disable-next-line no-useless-escape
            .replace(/\<|\>/g, ''),
          // eslint-disable-next-line no-useless-escape
          intent: intent.intentname.replace(/\<|\>/g, '')
        }),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        vm.loading = true
        vm.showModal = false
        data['id'] = intent.id
        const request = {
          data: data,
          params: {
            id: data['id']
          }
        }
        try {
          await this.putQvalIntents(request)
          if (vm.currentDefaultIntents) {
            const datapayload = {
              intentname: intent.intentname,
              questiondata: vm.currentDefaultIntents
            }

            await vm.saveTrainingIntent(datapayload)

            vm.currentDefaultIntents = []
            vm.loading = false
          }
        } catch (error) {
          console.error(error)
          vm.loading = false
        }
      }
    },
    putQvalIntents(request) {
      return new Promise((resolve, reject) => {
        api.putQvalIntents(request, function (error) {
          if (error) {
            reject(error)
          }

          resolve()
        })
      })
    },
    putupdateTrainingConversation: function (data, callback) {
      const vm = this
      api.putupdateTrainingConversation(data, function (error) {
        if (error) {
          console.error(error)
          callback()
          return
        }
        if (vm.training_intents.length <= 0) {
          callback(null)
          return false
        }
        const training_intents_index = vm.training_intents.findIndex((intent) => {
          return intent.questiondata == data.questiondata
        })
        if (training_intents_index != -1) {
          callback(training_intents_index)
        }
      })
    },
    saveTrainingIntent: function (payload) {
      return new Promise((resolve, reject) => {
        const datapayload = {
          intentname: payload.intentname,
          questiondata: payload.questiondata
        }

        this.updateTrainedToDefaultChatlog(datapayload).then((response) => {
          if (response) {
            this.selected = []
            this.loadTraining()
            resolve(response)
          } else {
            reject()
          }
        })
      })
    },
    ignoreAll: async function () {
      const vm = this
      const result = await vm.$swal.fire({
        title: vm.$t('Do you want to ignore selected?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('cancel'),
        reverseButtons: true
      })

      if (result.value) {
        vm.loading = true
        await vm.ignoreTrainingIntent(vm.selected)
        vm.selected = []
        await vm.loadTraining()

        vm.loading = false
      }
    },
    onIgnore: async function (id) {
      const vm = this
      const result = await vm.$swal.fire({
        title: vm.$t('Do you want to ignore selected?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        vm.loading = true
        vm.loadingId = id
        try {
          vm.selected = []
          await vm.ignoreTrainingIntent(vm.selected)
          await vm.loadTraining()
        } catch (error) {
          console.error(error)
        }
        vm.loading = false
      }
    },
    ignoreTrainingIntent: function (questiondata) {
      const vm = this
      return new Promise((resolve) => {
        const data = {
          pageid: vm.selectedBot.pageid,
          intentname: 'ignore',
          questiondata: questiondata
        }

        vm.saveTrainingIntent(data).then(() => {
          resolve()
        })
      })
    },
    selectAll: function (type) {
      const vm = this
      console.log('selectAll', type)
      const intents = vm.training_intents.map((el) => el.questiondata)
      if (type) {
        vm.selected = [
          ...vm.selected,
          ...vm.training_intents
            .map((el) => el.questiondata)
            .filter((el) => {
              return !vm.selected.includes(el)
            })
        ]
      } else {
        vm.selected = vm.selected.filter((el) => {
          return !intents.includes(el)
        })
      }
    },
    select: function () {
      this.allSelected = false
    },
    onExportTraining: async function () {
      const vm = this
      if (vm.loading) {
        return false
      }
      vm.loading = true
      const response = await vm.getTrainingConversation({ limit: vm.total, offset: 0 })
      const training_intents = response.training
      const json = training_intents.map((val) => ({
        message: (val.questiondata ? val.questiondata : '').replace(/\r?\n|\r/g, ' / '),
        count: val.count > 0 ? val.count : 0
      }))

      const dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, 'training.xlsx')
      vm.loading = false
    }
  }
}
</script>

<style scoped>
.primaryButton {
  margin-left: 0;
  margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/view/intent/Training/NonClassify/NewClassify.vue